import React from "react";
// import FormGroup from "app/Components/Form/FormGroup.component";
import SimpleSelect from "app/Components/SearchableSelect/SimpleSelect";
import InputError from "app/Components/_form/InputError/InputError";
import { Col, Row, FormGroup } from "react-bootstrap";
import { employeeFormLabel, employeeTrainingEligibilityList } from "../Constant";
import Label from "app/Components/_form/Label/Label";
import { useTraining } from "app/_helpers/hooks";
import DatePicker from "app/Components/DateTimeCustom/CustomDateTime";
import PreviousTrainingRecord from "./PreviousTrainingRecord";

function InitialTrainingForm({
  form = {},
  onChange,
  error = {},
  id,
  menuPortalTarget,
  isDisable,
  previousTraining,
  setPreviousTraining,
  preTrainingErr,
}) {
  const [, trainingOption] = useTraining("filter[type]=training");

  console.log("form", form);

  return (
    <div className="mt-2">
      {!form.isRefresherDate && (
        <>
          {!id && (
            <>
              <h5>Training</h5>
              <TrainingForm
                menuPortalTarget={menuPortalTarget}
                disabled={id}
                form={form}
                onChange={onChange}
                error={error}
                isDisable={isDisable}
              />
            </>
          )}
          {previousTraining && (
            <PreviousTrainingRecord
              previousTraining={previousTraining}
              setPreviousTraining={setPreviousTraining}
              trainingOption={trainingOption}
              preTrainingErr={preTrainingErr}
            />
          )}
        </>
      )}

      {form.isRefresherDate === true && (
        <Row>
          <Col md={4}>
            <FormGroup>
              <Label>{employeeFormLabel["lastRefresherTrainingDate"]}</Label>

              <DatePicker
                name={"lastRefresherTrainingDate"}
                value={form.lastRefresherTrainingDate}
                onChangeDate={onChange}
                label={employeeFormLabel["lastRefresherTrainingDate"]}
                placeHolder={employeeFormLabel["lastRefresherTrainingDate"]}
                error={error["lastRefresherTrainingDate"]}
                // disabled={!form.employmentStatus}
              />
              <InputError error={error["lastRefresherTrainingDate"]} />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <Label>{employeeFormLabel["trainingDesignation"]}</Label>

              <SimpleSelect
                name={"trainingDesignation"}
                value={+form?.trainingDesignation}
                onChange={onChange}
                options={trainingOption}
                // label={"name"}
                // id="value"
                placeHolder={employeeFormLabel["trainingDesignation"]}
              />
              <InputError error={error["trainingDesignation"]} />
            </FormGroup>
          </Col>
        </Row>
      )}
    </div>
  );
}

const TrainingForm = ({
  form,
  onChange,
  error,
  disabled,
  menuPortalTarget,
  isDisable,
}) => {
  const [, trainingOption] = useTraining("filter[type]=training");

  console.log("error", error);

  return (
    <Row>
      <Col md={4}>
        <FormGroup>
          <Label>{employeeFormLabel["trainingEligibility"]}</Label>

          <SimpleSelect
            name={"trainingEligibility"}
            value={form.trainingEligibility}
            options={employeeTrainingEligibilityList}
            onChange={onChange}
            placeHolder={employeeFormLabel["trainingEligibility"]}
            label={"name"}
            id="value"
            menuPortalTarget={menuPortalTarget}
            disabled={isDisable ? isDisable : false}
          />
          <InputError error={error["trainingEligibility"]} />
        </FormGroup>
      </Col>
      <Col md={4}>
        <FormGroup>
          <Label>{employeeFormLabel["trainingDesignation"]}</Label>

          <SimpleSelect
            name={"trainingDesignation"}
            value={+form?.trainingDesignation}
            onChange={onChange}
            options={trainingOption}
            // label={"name"}
            // id="value"
            placeHolder={employeeFormLabel["trainingDesignation"]}
            disabled={
              form.trainingEligibility !== "yes" ? true : isDisable ? isDisable : false
            }
            menuPortalTarget={menuPortalTarget}
          />
          <InputError error={error["trainingDesignation"]} />
        </FormGroup>
      </Col>

      {/* <Col md={4}>
          <FormGroup>
            <Label>{employeeFormLabel["designationChangeTrainingDate"]}</Label>
  
            <DatePicker
              name={"designationChangeTrainingDate"}
              value={form.designationChangeTrainingDate}
              onChangeDate={onChange}
              label={employeeFormLabel["designationChangeTrainingDate"]}
              placeHolder={employeeFormLabel["designationChangeTrainingDate"]}
              disabled={true}
            />
            <InputError error={error["designationChangeTrainingDate"]} />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label>{employeeFormLabel["designationChangeTrainingStatus"]}</Label>
  
            <SimpleSelect
              name={"designationChangeTrainingStatus"}
              value={form.designationChangeTrainingStatus}
              onChange={onChange}
              placeHolder={employeeFormLabel["designationChangeTrainingStatus"]}
              options={employeeTrainingStatus}
              label={"name"}
              disabled={true}
              id="value"
            />
  
            <InputError error={error["designationChangeTrainingStatus"]} />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label>{employeeFormLabel["basicTrainingCompletionDate"]}</Label>
  
            <DatePicker
              name={"basicTrainingCompletionDate"}
              value={form.basicTrainingCompletionDate}
              onChangeDate={onChange}
              label={employeeFormLabel["basicTrainingCompletionDate"]}
              placeHolder={employeeFormLabel["basicTrainingCompletionDate"]}
              disabled={disabled}
            />
            <InputError error={error["basicTrainingCompletionDate"]} />
          </FormGroup>
        </Col>
  
        <Col md={4}>
          <FormGroup>
            <Label>{employeeFormLabel["lastRefresherTrainingDate"]}</Label>
  
            <DatePicker
              name={"lastRefresherTrainingDate"}
              value={form.lastRefresherTrainingDate}
              onChangeDate={onChange}
              label={employeeFormLabel["lastRefresherTrainingDate"]}
              placeHolder={employeeFormLabel["lastRefresherTrainingDate"]}
              disabled={disabled}
            />
            <InputError error={error["lastRefresherTrainingDate"]} />
          </FormGroup>
        </Col> */}
    </Row>
  );
};

export default InitialTrainingForm;
